<template>
    <div>
        <div class="base-search-container mb10">
            <swb-query-sort-area ref="query_model" :config="queryConfig" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <swb-result-table name="result_table" ref="result_table" :config="resultConfig" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :pageSizeList="pageSizes" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
import { Utils, $ } from '../../app.base'
import { Vue, MsgBox, DomSizeWatcher } from '../../app.vues'

import SwbQuerySortArea from '../query/QuerySortArea';

Vue.regist(SwbQuerySortArea);
//
import goodsDelivApi from '../../api/goodsDeliv'
//
let searchConfigData = {
    "queryFields": [{
        "type": "Text",
        "label": "商品标识码",
        "code": "no",
        "valueType": "String",
        "basic": true
    }, {
        "type": "Text",
        "label": "使用机构",
        "code": "retailerComName",
        "valueType": "String",
        "basic": true
    }, {
        "code": "ukno",
        "label": "商品标识码",
        "type": "Num2",
        "valueType": "Integer",
        "basic": true,
        "hidden": false,
        "rptUsed": false,
        "ctxBindName": null
    }]
};
let resultConfigData = {
    metaCols: [
        {
            "name": "no",
            "text": "商品标识码",
            "dataType": "string",
            "width": 230,
            "align": "left",
            "overflowAsTip": true,
            "format": null,
            "asTpl": false
        },
        {
            "name": "retailerComId",
            "text": "是否使用",
            "dataType": "bool",
            "width": 80,
            "align": "center",
            "overflowAsTip": false,
            "format": "是/否",
            "asTpl": false
        },
        {
            "name": "retailerComName",
            "text": "使用机构",
            "dataType": "string",
            "width": null,
            "align": "left",
            "overflowAsTip": false,
            "format": null,
            "asTpl": false
        },
        {
            "name": "retailerInnerNo",
            "text": "外部系统编号",
            "dataType": "string",
            "width": 250,
            "align": "left",
            "overflowAsTip": false,
            "format": null,
            "asTpl": false
        },
        {
            "name": "creatorName",
            "text": "操作人",
            "dataType": "string",
            "width": 150,
            "align": "left",
            "overflowAsTip": false,
            "format": null,
            "asTpl": false
        },
        {
            "name": "createTime",
            "text": "创建时间",
            "dataType": "date",
            "width": 150,
            "align": "center",
            "overflowAsTip": false,
            "format": null,
            "asTpl": false
        },
        {
            "name": "invalid",
            "text": "是否有效",
            "dataType": "bool",
            "width": 80,
            "align": "center",
            "overflowAsTip": false,
            "format": "已作废/正常",
            "asTpl": false
        }
    ]
};
//
export default {
    name: 'swb-mercht-goods-uk-no-select',
    avlActions: '',
    avlScopes: 'mercht',
    desc: '商品标识码列表',
    props: {
        checkedIds: {// 多选的时候传入
            type: Array,
            default: function () {
                return [];
            }
        },
        multiSelect: {
            type: Boolean,
            default: false
        },
        itemId: {
            type: Number,
        },
        voucherId: {
            type: Number,
        },
        excludeRetailerId: {
            type: Number,
            default: null
        },
        disabledFlag: {
            type: Boolean,
            default: true
        },
        returnFlag: { // 回收标识
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            confKey: 'swb-shop-device-svc-sub-no-list',
            theTableHeight: 600,
            //
            needPager: true, //是否需要分页（默认：true）
            multiSelect: true, //是否多选（默认：false）
            multiPageSelect: true, //是否要多页/跨页选择（默认：false）
            rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
            rowNoShow: false, //是否显示行号（默认：true）
            rowNoFixed: false, //行号列是否固定（默认：false）

            btnColName: null,//操作列名称（如果不设置就不显示操作列）
            //
            btnColTitle: '操作',//操作列标题（默认：'操作'）
            btnColWidth: 200,//操作列宽度（默认：100）
            //
            btnColFixed: true, //操作列是否固定
            //
            queryConfig: null,
            resultConfig: null,
            //
            totalCount: 0,
            pageSizes: [10, 50, 100, 200, 500],
            pageSize: 10,
            pageNumber: 1,
            queryModel: {
                filterItems: {},
                sortItemList: [],
                sortItems: {},
            },
            disabledItemIds: [],
        }
    },
    created: function () {
        let self = this;
        this.pageSize = this.pageSizes.first();
        //
        this.queryConfig = Utils.merge({}, searchConfigData);
        this.resultConfig = Utils.merge({}, resultConfigData);
        //
        if(this.disabledFlag) {
            this.disabledItemIds = self.checkedIds;
        } else {
            this.checkedItemIds = self.checkedIds;
        }
        //
        this.getMerchtGoodsUknoList();
    },
    mounted() {
        let self = this;
        //注册domSizeWatcher
        let thisEl = $(this.$el);
        $(this.$el).addClass('overflow-hidden');
        //
        let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
        domSizeWatcher.setBaseEl(thisEl);
        domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
            //根据新主元素的内容大小，调整表格高度
            self.theTableHeight = height;
        });
        //domSizeWatcher.setHrEls();
        domSizeWatcher.setVtEls(thisEl.find('.base-search-container'));
        domSizeWatcher.start(500);
        //
        this.initResultTable();
        // 回显数据处理
        let resultTable = this.$refs.result_table;
        resultTable.setInitChecked(this.disabledItemIds, true);
    },
    destroyed() {
        //释放domSizeWatcher
        let domSizeWatcher = this.domSizeWatcher;
        if(domSizeWatcher != null) {
            domSizeWatcher.clear();
            this.domSizeWatcher = null;
        }
    },
    methods: {
        initResultTable() {
            let self = this;
            let query_model_ctrl = this.$refs['query_model_ctrl'];
            let resultTable = this.$refs['result_table'];
            //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
            resultTable.setQrySortRef(query_model_ctrl);
            //
            resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                'retailerComId': function (row, colName, colValue, rowIndex, colConf) {
                    if(Utils.isNoB(row.retailerComId)) {
                        return '<span class="font-red">未使用</span>';
                    } else {
                        return '<span class="font-green">已使用</span>';
                    }
                },
                'invalid': function (row, colName, colValue, rowIndex, colConf) {
                    if(row.invalid) {
                        return '<span class="font-red" v-if="scope.row.invalid">已作废</span>';
                    } else {
                        return '<span class="font-green" v-if="!scope.row.invalid">正常</span>';
                    }
                },
                'actions': function (row, colName, colValue, rowIndex) {
                    return [];
                }
            }, /* 单元格按钮点击处理函数 */{
                //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                'actions': function (row, colName, colValue, rowIndex, btnName) {
                }
            });
        },
        renderTable(rows, pagination) {
            let resultTable = this.$refs.result_table;
            let tableData = {
                rows: rows,
                pagination: pagination
            };
            resultTable.render(tableData);
        },
        // 单元格点击事件
        rowDblClickHandler: function (row) {
            if(!this.multiSelect) {
                console.log("----- 双击数据行 ----");
                console.log(row);
            }
        },
        getTableSelection() {
            return this.$refs.result_table.getSelection();
        },
        queryHandler(queryModel) {
            this.queryModel = queryModel;
            this.pageNumber = 1;
            this.lastPageNumber = null;
            //
            this.getMerchtGoodsUknoList();
        },
        pageNoChangeHandler: function (pageNumber, pageSize) {
            this.pageSize = pageSize;
            this.pageNumber = pageNumber;
            this.lastPageNumber = null;
            //
            this.getMerchtGoodsUknoList();
        },
        getMerchtGoodsUknoList: function () {
            let self = this;
            let postData = {};
            postData.pagination = {
                pageSize: self.pageSize,
                pageNumber: self.pageNumber,
            };
            //
            let queryModel = self.queryModel;
            let filterItems = queryModel.filterItems;
            if(!Utils.isNoB(self.itemId) || !Utils.isNoB(self.voucherId)) {
                filterItems.shipVoucherItemId = self.itemId;
                filterItems.shipVoucherId = self.voucherId;
            }
            if(self.multiSelect && Utils.isNoB(self.itemId) && Utils.isNoB(self.voucherId)) {
                if(!Utils.isTrue(self.returnFlag)) {
                    filterItems.isOccupy = false;
                }
                filterItems.used = false;
                filterItems.invalid = false;
                if(self.excludeRetailerId != null) {
                    filterItems.excludeRetailerId = self.excludeRetailerId;
                }
            }
            postData.filterItems = Utils.merge({}, filterItems);
            postData.sortItemList = Utils.merge([], queryModel.sortItemList);
            postData.sortItems = Utils.merge({}, queryModel.sortItems);
            //
            let theLoad = MsgBox.loading();
            goodsDelivApi.getMerchtGoodsUknoList(postData, function (result) {
                theLoad.hide();
                if(result.type === "info") {
                    self.totalCount = result.data.pagination.totalCount;
                    self.renderTable(result.data.rows, result.data.pagination);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        getDlgResult: function () {
            let self = this;
            let result = {};
            let merchtGoodsUknoList = this.getTableSelection() || [];
            if(!Utils.isNoB(merchtGoodsUknoList) && merchtGoodsUknoList.length > 0) {
                result.data = merchtGoodsUknoList;
                result.type = "info";
            } else {
                result.type = "warn";
                result.message = "请选择的编码";
            }
            return result;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/asset/MerchtGoodsUknoSelect.vue